import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked",
  "use": "checked-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 9\" id=\"checked\"><path d=\"M1.707 2.783.293 4.198 4.26 8.164l6.457-6.457L9.303.293 4.26 5.336\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol